import {Model} from 'MWC';
import {formatter} from 'MWComponents';
import {Validator} from '../../ExpressOrder/validator/validator';

const PHONE_NUMBER = 'contactPhoneNumber',
    formatsArr = {
        [PHONE_NUMBER]: '_phoneFormat'
    };

export default class extends Model {
    static fields;

    isValid = false;

    constructor(data) {
        super();
        this.initData(data);
    }

    initData(data) {
        this.fields = {
            customerNameOrCite: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty]
            },

            contactPhoneNumber: {
                value: '',
                firstInput: true,
                isValid: true,
                errors: [],
                validates: [Validator.isNotEmpty, Validator.phone]
            },

            name: {
                value: '',
                firstInput: true,
                errors: [Validator.isNotEmpty]
            },

            email: {
                value: '',
                firstInput: true,
                errors: [Validator.isNotEmpty, Validator.email]
            }
        };
    }

    getField(fieldName) {
        return this.fields[fieldName];
    }

    run(data) {
        const name = data.name,
            value = formatsArr[name] ? this[formatsArr[name]](data.value) : data.value;

        this.fields[name].value = value;

        this.isValid = this.validate();
    }

    changeFirst(name) {
        this.fields[name].firstInput = false;
    }

    validate() {
        let result = true;
        // eslint-disable-next-line guard-for-in
        for (const item in this.fields) {
            Validator.validate(this.fields[item]);
            if (!this.fields[item].isValid) {
                result = false;
            }
        }

        return result;
    }

    _phoneFormat = value => {
        return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
    };

    _sumFormat = value => {
        return formatter(value, '{ddd} {ddd}');
    };
}
